import React from "react"
import { DarkModeProvider } from "../utils/darkMode"
import Layout from "./layout"

export default function PageRoot({ element, props }) {
  return <DarkModeProvider>
    <Layout {...props}>
      {element}
    </Layout>
  </DarkModeProvider>
}

